module.exports = __webpack_public_path__ + "static/Realty-657e644327e40dd3a93c329d2e822f58.mp4";